import React, { useState, useEffect, useContext } from 'react';
import './Cart.css';
import Cartorders from '../Cartorders/Cartorders';
import { useUser } from '../../Context/UserContext';
import { useNavigate } from 'react-router-dom';
import { useNav } from '../../Context/NavContext';
import Myorders from '../Myorders/Myorders';
import { UrlContext } from '../../Context/UrlContext';

function Cart() {

  const [category, setCategory] = useState('cart'); // default to 'cart'
  const { user } = useUser();
  const navigate = useNavigate();
  const { setActiveItem } = useNav();

  useEffect(() => {
    if (!user || !user.id) {
      setActiveItem('ACCESS');
      navigate('/');
    }
  }, [user, navigate, setActiveItem]);

  if (!user || !user.id) {
    return null;
  }

  return (
    <div className='cart_container'>
      <div className="cart_top">
        <div className="cart_title">
          <h2>{category === 'cart' ? 'Your Cart' : 'Your Orders'}</h2>
        </div>
        <div className="top_filter">
          <select
            id="categorySelect"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="cart">Your Cart</option>
            <option value="orders">Orders</option>
          </select>
        </div>
      </div>

      <div className="cart_body">
       {category === 'cart' ? (
  <Cartorders setCategory={setCategory} />
) : (
  <Myorders />
)}

      </div>
    </div>
  );
}

export default Cart;
